
import request from '@/utils/request'
import qs from 'qs'


export const login = data => request({
  url: '/yj?op=PcloginCheck',
  method: 'post',
  data:qs.stringify({    //这里是发送给后台的数据
                      userName:data.userName,
                      userPw:data.userPw,
                })
})

export const getUserInfo = data => request({
  url: '/yj?op=getuserinfo',
  method: 'post',
  data
})

export const logout = params => request({
  url: '/yj?op=loginOut',
  method: 'get'
})
